import {http, https, httpsFile} from './http';

export function index(company,storage_location){
    return https().get(`po-import-items?company=${company}&storage_location=${storage_location}`);
}

export function poImport(data){
    return httpsFile().post(`po-import-items`,data);
}

export function deleteAll(){
    return https().post(`cancel-po-import-items`);
}

export function createPo(data){
    return https().post(`create-po-import-items`,data);
}